/**
 * Desktop (`lg` and up) header band of the Certification & Compliance page: breadcrumb, a 75px
 * white title and the subtitle on a `tertiary` `ContentSection`.
 */
import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@ryerson/frontend.theme";
import { ContentSection, Flex } from "@ryerson/frontend.layout";
import { Breadcrumb } from "@ryerson/frontend.navigation";
import { Typography } from "@ryerson/frontend.typography";
import {
	CertificationAndComplianceHeaderContent,
	CertificationAndComplianceHeaderText,
} from "./CertificationAndComplianceHeaderContent";
import { useApplication } from "@ryerson/frontend.application";

const HeaderBreadcrumb = styled(Breadcrumb)`
	margin-top: 25px;
`;

const HeaderTitle = styled(Typography)`
	margin: 25px 0;
	font-size: 75px;
`;

const HeaderSubtitle = styled(Typography)`
	margin-top: 10px;
	margin-bottom: 40px;
`;

/** Renders the desktop header band in the visitor's language. It takes no props. */
const CertificationAndComplianceHeaderDesktop: React.FC = ({ ...props }) => {
	const { theme } = useTheme();
	const { white } = theme.colors.primary;

	const {
		localization: { language },
	} = useApplication();

	const content: CertificationAndComplianceHeaderText =
		CertificationAndComplianceHeaderContent[language];

	return (
		<ContentSection type="tertiary">
			<Flex direction="column">
				<HeaderBreadcrumb size="xs" type="tertiary" />
				{/* The `css` margins win over `HeaderTitle`'s `margin: 25px 0`: Emotion appends
				    css-prop styles after the styled component's own. */}
				<HeaderTitle
					variant="h1"
					color={white}
					css={{ marginTop: "16px", marginBottom: "34px" }}
				>
					{content.title}
				</HeaderTitle>
				<HeaderSubtitle variant="p" type="tertiary">
					{content.subtitle}
				</HeaderSubtitle>
			</Flex>
		</ContentSection>
	);
};

export default CertificationAndComplianceHeaderDesktop;
